import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-855b925e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12 col-md-4 mb-4" }
const _hoisted_5 = { class: "card border" }
const _hoisted_6 = { class: "card-body d-flex align-items-end" }
const _hoisted_7 = { class: "d-flex align-items-center flex-column mt-3 w-100" }
const _hoisted_8 = { class: "fs-3x fw-bolder text-dark lh-1" }
const _hoisted_9 = { class: "d-flex justify-content-between w-100 my-2" }
const _hoisted_10 = { class: "fs-3 text-dark" }
const _hoisted_11 = { class: "fw-bolder fs-3 text-gray-400" }
const _hoisted_12 = { class: "bg-light-success h-8px mx-3 w-100 rounded" }
const _hoisted_13 = { class: "col-sm-12 col-md-4 mb-4" }
const _hoisted_14 = { class: "card border" }
const _hoisted_15 = { class: "card-body d-flex align-items-end" }
const _hoisted_16 = { class: "d-flex align-items-center flex-column mt-3 w-100" }
const _hoisted_17 = { class: "fs-3x fw-bolder text-dark lh-1" }
const _hoisted_18 = { class: "d-flex justify-content-between w-100 my-2" }
const _hoisted_19 = { class: "fs-3 text-dark" }
const _hoisted_20 = { class: "fw-bolder fs-3 text-gray-400" }
const _hoisted_21 = { class: "bg-light-warning h-8px mx-3 w-100 rounded" }
const _hoisted_22 = { class: "col-sm-12 col-md-4 mb-4" }
const _hoisted_23 = { class: "card border" }
const _hoisted_24 = { class: "card-body d-flex align-items-end" }
const _hoisted_25 = { class: "d-flex align-items-center flex-column mt-3 w-100" }
const _hoisted_26 = { class: "fs-3x fw-bolder text-dark lh-1" }
const _hoisted_27 = { class: "d-flex justify-content-between w-100 my-2" }
const _hoisted_28 = { class: "fs-3 text-dark" }
const _hoisted_29 = { class: "fw-bolder fs-3 text-gray-400" }
const _hoisted_30 = { class: "bg-light-danger h-8px mx-3 w-100 rounded" }
const _hoisted_31 = { class: "row mb-4" }
const _hoisted_32 = { class: "col-sm-12 col-md-6 mt-md-0 mt-4" }
const _hoisted_33 = { class: "card card-flush h-xxl-100 border" }
const _hoisted_34 = { class: "card-body d-flex flex-column justify-content-between pb-5" }
const _hoisted_35 = {
  key: 0,
  id: "chart",
  class: "w-100"
}
const _hoisted_36 = { class: "text-truncate" }
const _hoisted_37 = { class: "text-truncate" }
const _hoisted_38 = { class: "text-truncate me-3" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "text-truncate me-3" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "text-truncate me-3" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-toggle": "dropdown",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" })
], -1))
const _hoisted_51 = { class: "dropdown-menu dropdown-menu-end border detail-dropdown" }
const _hoisted_52 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_LineChartModal = _resolveComponent("LineChartModal")!
  const _component_FormDetailModal = _resolveComponent("FormDetailModal")!
  const _component_ViewFormDetailModal = _resolveComponent("ViewFormDetailModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.onTimeCount), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t("common.onTime")), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.ontimePercentage), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "bg-on-time rounded h-8px",
                    role: "progressbar",
                    style: _normalizeStyle({ width: _ctx.ontimePercentage }),
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 4)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.outsidePeriodCount), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t("common.outsidePeriod")), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.outsidePercentage), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "bg-outside-period rounded h-8px",
                    role: "progressbar",
                    style: _normalizeStyle({ width: _ctx.outsidePercentage }),
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 4)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.expiredCount), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.t("common.expired")), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.expiredPercentage), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", {
                    class: "bg-expired rounded h-8px",
                    role: "progressbar",
                    style: _normalizeStyle({ width: _ctx.expiredPercentage }),
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 4)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_LineChart, {
          dateFilterValue: _ctx.dateFilterValue,
          reference: "form",
          column: _ctx.column,
          webId: 0
        }, null, 8, ["dateFilterValue", "column"]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (!_ctx.pieChartLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_apexchart, {
                      type: "donut",
                      width: "550",
                      options: _ctx.pieChartOptions,
                      series: _ctx.pieSeries
                    }, null, 8, ["options", "series"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        total: _ctx.total,
        rowsPerPage: _ctx.rowsPerPage,
        page: _ctx.page,
        loading: _ctx.loading,
        showSearch: _ctx.showSearch,
        defaultFilter: _ctx.defaultFilter,
        tableFilter: _ctx.tableFilter,
        viewName: "forms-table-dashboard",
        onQueryUpdate: _ctx.queryUpdate,
        onTableRowClick: _ctx.tableRowClick
      }, {
        "cell-siteName": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_36, _toDisplayString(site.siteName), 1)
        ]),
        "cell-formName": _withCtx(({ row: form }) => [
          _createElementVNode("span", _hoisted_37, _toDisplayString(form.formName), 1)
        ]),
        "cell-onTime": _withCtx(({ row: form }) => [
          _createElementVNode("span", _hoisted_38, _toDisplayString(+form.onTime), 1),
          _createElementVNode("span", {
            innerHTML: _ctx.format.upDownIndicator(form.onTimePercentage, 'on-time')
          }, null, 8, _hoisted_39)
        ]),
        "cell-outsidePeriod": _withCtx(({ row: form }) => [
          _createElementVNode("span", _hoisted_40, _toDisplayString(+form.outsidePeriod), 1),
          _createElementVNode("span", {
            innerHTML: 
              _ctx.format.upDownIndicator(
                form.outsidePeriodPercentage,
                'outside-period'
              )
            
          }, null, 8, _hoisted_41)
        ]),
        "cell-expire": _withCtx(({ row: form }) => [
          _createElementVNode("span", _hoisted_42, _toDisplayString(+form.expire), 1),
          _createElementVNode("span", {
            innerHTML: _ctx.format.upDownIndicator(form.expirePercentage, 'expired')
          }, null, 8, _hoisted_43)
        ]),
        "cell-status": _withCtx(({ row: form }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text-truncate fw-bolder", {
              'badge badge-success mt-2':
                form.status?.toLowerCase() === 'active',
              'badge badge-danger mt-2':
                form.status?.toLowerCase() !== 'active',
            }])
          }, _toDisplayString(_ctx.format.TitleCase(form.status?.toLowerCase())), 3)
        ]),
        "cell-actions": _withCtx(({ row: form }) => [
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (_ctx.openModal('chart', form)), ["prevent"]),
            class: "btn btn-icon btn-info btn-circle btn-sm"
          }, _hoisted_46, 8, _hoisted_44),
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (_ctx.openViewModal(form)), ["prevent"]),
            class: "btn btn-icon btn-primary btn-circle btn-sm mx-3"
          }, _hoisted_49, 8, _hoisted_47),
          _hoisted_50,
          _createElementVNode("ul", _hoisted_51, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (_ctx.openModal('detail', form)), ["prevent"]),
                class: "dropdown-item py-2 text-hover-primary",
                type: "button"
              }, _toDisplayString(_ctx.t("common.detail")), 9, _hoisted_52)
            ])
          ])
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "onQueryUpdate", "onTableRowClick"]),
      _createVNode(_component_LineChartModal, {
        viewName: "form_line_chart_modal",
        data: _ctx.selectedForm,
        reference: "form",
        dateFilterValue: _ctx.dateFilterValue,
        title: _ctx.selectedForm.name,
        showDialog: _ctx.showChartDialog,
        onCloseChart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showChartDialog = false))
      }, null, 8, ["data", "dateFilterValue", "title", "showDialog"]),
      _createVNode(_component_FormDetailModal, {
        viewName: "form_detail_modal",
        data: _ctx.selectedForm,
        showDialog: _ctx.showDetailDialog,
        onCloseDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetailDialog = false))
      }, null, 8, ["data", "showDialog"]),
      _createVNode(_component_ViewFormDetailModal, {
        viewName: "view_form_detail_modal",
        data: _ctx.viewSelectedForm,
        dateFilter: _ctx.dateFilterValue,
        showDialog: _ctx.showViewDetailDialog,
        onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showViewDetailDialog = false))
      }, null, 8, ["data", "dateFilter", "showDialog"])
    ])
  ]))
}